import _ from 'lodash'
import { pluck, sum } from 'ramda'
import React, { useMemo } from 'react'
import styled from 'styled-components'

import { isNotNull } from '../../../../../../utils/collectionTools'
import { formatAsCurrency, formatAsCurrencyOrZero } from '../../../../../../utils/priceTools'
import { OrderPageData } from '../types'
import * as Styled from './styled'

const pluckLineDiscount = pluck('discountAmount')

export interface OrderTotalProps {
  className?: string
  order: OrderPageData
}

const OrderTotal: React.FC<OrderTotalProps> = ({ className, order }) => {
  const orderItems = useMemo(() => {
    return order.items?.filter(isNotNull) ?? []
  }, [order.items])

  const additionalDiscount = useMemo(() => {
    const sumOfLineDiscounts = sum(pluckLineDiscount(orderItems))
    // round to avoid floating point artifacts
    return Math.max(_.round(order.discountTotal - sumOfLineDiscounts, 3), 0)
  }, [orderItems, order.discountTotal])

  return (
    <div className={className}>
      <Styled.OrderTotalDetail>
        <span>Subtotal:</span>
        <span>{formatAsCurrencyOrZero({ amount: order.subtotal })}</span>
      </Styled.OrderTotalDetail>
      <Styled.OrderTotalDetail>
        <span>Shipping:</span>
        <span>{formatAsCurrencyOrZero({ amount: order.shippingTotal })}</span>
      </Styled.OrderTotalDetail>
      <Styled.OrderTotalDetail>
        <span>Sales Tax:</span>
        <span>{formatAsCurrencyOrZero({ amount: order.taxTotal })}</span>
      </Styled.OrderTotalDetail>
      {order.coloradoRetailDeliveryFee && (
        <Styled.OrderTotalDetail>
          <span>Colorado Retail Delivery Fee:</span>
          <span>{formatAsCurrency({ amount: order.coloradoRetailDeliveryFee })}</span>
        </Styled.OrderTotalDetail>
      )}
      {additionalDiscount > 0 && additionalDiscount !== order.discountTotal && (
        <Styled.OrderTotalDetail>
          <span>Additional Discount:</span>
          <span>{formatAsCurrencyOrZero({ amount: additionalDiscount * -1 })}</span>
        </Styled.OrderTotalDetail>
      )}
      {order.discountTotal > 0 && (
        <Styled.OrderTotalDetail>
          <span>Total Discount:</span>
          <span>{formatAsCurrencyOrZero({ amount: order.discountTotal * -1 })}</span>
        </Styled.OrderTotalDetail>
      )}
      <Styled.OrderTotalDetail>
        <span>Order Total:</span>
        <span>{formatAsCurrencyOrZero({ amount: order.total })}</span>
      </Styled.OrderTotalDetail>
    </div>
  )
}

const StyledOrderTotal = styled(OrderTotal)`
  font-size: 15px;
  line-height: 30px;
`

export { StyledOrderTotal as OrderTotal }
